import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import 'rxjs/Rx';
@Injectable({
  providedIn: 'root'
})

export class FlashInsightsService {

  constructor(
    private http: HttpClient
  ) { }

  public FlashInsightsId = "";
  public action = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };
  GetAllFlashInsightsDetails(){
    return this.http.get(environment.apiURL + `flashinsights/GetAllFlashInsightsDetails?IsActive=true`);
  }
  GetAllFlashInsightsDetailsByCreatedDate(date){
    return this.http.get(environment.apiURL + `flashinsights/GetAllFlashInsightsDetails?IsActive=true&CreatedOn=`+date);
  }
  GetAllFlashInsightsDetailsByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `flashinsights/GetAllFlashInsightsDetails?IsActive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetFlashInsightsDetailsById(FlashInsightsId){
    return this.http.get(environment.apiURL + `flashinsights/GetAllFlashInsightsDetails?_id=`+FlashInsightsId);
  }
  GetCompetitor(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndustry(){
    return this.http.get(environment.apiURL + `master/GetIndustry`);
  }  

  GetCompanyNames(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetCategorization(){
    return this.http.get(environment.apiURL + `master/GetCategorization`);
  }
  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }
  
  GetAllProductDetails(){
    return this.http.get(environment.apiURL+`product/GetAllProductDetails`);
  }
  AddFlashInsights(data){
    return this.http.post(environment.apiURL + `flashinsights/AddFlashInsights`, data);
  }
  UpdateFlashInsights(data){
    return this.http.post(environment.apiURL + `flashinsights/UpdateFlashInsights`, data);
  }
  DeleteFlashInsights(data){
    return this.http.post(environment.apiURL + `flashinsights/DeleteFlashInsights`, data);
  }
  UploadFlashInsightsImage(formData){    
    return this.http.post(environment.apiURL + `flashinsights/UploadFlashInsightsImage`, formData, this.options);
  }
  UploadFlashInsightsAttachment(formData){    
    return this.http.post(environment.apiURL + `flashinsights/UploadFlashInsightsAttachment`, formData, this.options);
  }
  getImage(imageUrl: string) {
    return this.http.get(imageUrl, {observe: 'response', responseType: 'blob'})
      .map((res) => {
        return new Blob([res.body], {type: res.headers.get('Content-Type')});
      })
  }

  GetUserFlashInsights(data){
    return this.http.post(environment.apiURL + `flashinsights/GetUserFlashInsights`, data);
  }
  GetSharedFlashInsightsDetailsById(FlashInsightsId){
    return this.http.get(environment.apiURL + `flashinsights/GetSharedUserFlashInsights?_id=`+FlashInsightsId);
  }
  SendSharedFlashInsightsEmail(data){
    return this.http.post(environment.apiURL + `email/Send`, data);
  }
  GetUserProduct(data){
    return this.http.post(environment.apiURL + `product/GetUserProduct`, data);
  }
  GetFlashInsightsByTitle(title){
    return this.http.get(environment.apiURL + `flashinsights/GetAllFlashInsightsDetails?IsActive=true&Title=`+title);
  }
}
